import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-datenschutz',
  standalone: true,
  imports: [],
  templateUrl: './datenschutz.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './datenschutz.component.scss'
})
export class DatenschutzComponent {

}
